
<div class="lm-border pa-3">
    <f-title title="Adressen" class="mt-0" />
    <v-row class="mt-0">
        <p-inc-invoice-recipient
            v-model     = "data.benefitRecipient"
            :usage      = "usage"
            :separated  = "separated"
            :type       = "`Leistungsempfänger`"
            :recipients = "benefit"
            :collective = "collective"
        />
    </v-row>
    <v-row class="mt-6">
        <p-inc-invoice-recipient
            v-model     = "data.invoiceRecipient"
            :usage      = "usage"
            :separated  = "separated"
            :type       = "`Rechnungsempfänger`"
            :recipients = "invoice"
            :collective = "collective"
        />
    </v-row>
</div>
